// FMO Agency Detail - Drill-through to individual agency
import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { ArrowLeft, RefreshCw, Users, AlertTriangle, Building2, ChevronRight } from 'lucide-react';

const BASE = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');

export default function FmoAgencyDetail() {
  const { agencyId } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchDetail = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetch(`${BASE}/fmo/agencies/${agencyId}`, { credentials: 'include' });
      const json = await res.json();
      if (json.ok) setData(json);
    } catch (err) { console.error('[FMO AgencyDetail]', err); }
    finally { setLoading(false); }
  }, [agencyId]);

  useEffect(() => { fetchDetail(); }, [fetchDetail]);

  if (loading) return <div className="min-h-screen bg-gray-50 flex items-center justify-center"><RefreshCw className="w-8 h-8 text-amber-500 animate-spin" /></div>;
  if (!data) return <div className="min-h-screen bg-gray-50 p-6"><p className="text-gray-500">Agency not found</p></div>;

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-white border-b border-gray-200 px-6 py-4">
        <div className="max-w-7xl mx-auto flex items-center gap-4">
          <button onClick={() => navigate('/fmo/agencies')} className="p-2 hover:bg-gray-100 rounded-lg">
            <ArrowLeft size={20} className="text-gray-600" />
          </button>
          <div>
            <h1 className="text-2xl font-bold text-[#172A3A]">{data.agency?.name || 'Agency'}</h1>
            <p className="text-sm text-gray-500">{data.agents?.length || 0} agents</p>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto p-6 space-y-6">
        <div className="bg-white rounded-2xl shadow-sm border border-gray-200">
          <div className="px-6 py-4 border-b border-gray-200">
            <h3 className="font-semibold text-gray-900">Agents</h3>
          </div>
          <div className="divide-y divide-gray-100">
            {(data.agents || []).map(agent => (
              <div key={agent.id} className="px-6 py-4 flex items-center justify-between hover:bg-gray-50">
                <div>
                  <p className="font-semibold text-gray-900">{agent.name}</p>
                  <p className="text-xs text-gray-400">{agent.email}</p>
                </div>
                <div className="flex items-center gap-4 text-sm">
                  <span className="text-gray-600">{agent.clientCount} clients</span>
                  {agent.atRisk > 0 && (
                    <span className="text-red-600 flex items-center gap-1"><AlertTriangle size={14} />{agent.atRisk}</span>
                  )}
                  <span className={`w-2 h-2 rounded-full ${agent.isActive ? 'bg-green-500' : 'bg-gray-300'}`} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
